import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Objeto } from 'app/core/models/objeto.model';
import { ObjetoService } from 'app/core/services/objeto.service';
import { UsuarioService } from 'app/core/services/usuario.service';

@Injectable()
export class MenuRouteGuard implements CanActivate {
    private router = inject(Router);
    private objetoService = inject(ObjetoService);
    private usuarioService = inject(UsuarioService);

    private readonly idServico = 'b2aec844-32a6-461f-8276-333e19dab857';

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (route.routeConfig && route.routeConfig.path === 'pages') {
            return true;
        }
        const requestedRootPath = this.getRootPath(state.url);
        if (!requestedRootPath) {
            return true;
        }

        const perfis = this.usuarioService.getRole();
        return this.objetoService.menuUser(this.idServico).pipe(
            map(res => this.extractAllowedRootPaths(res && res.data ? res.data : [], perfis)),
            map(paths => this.handleAuthorization(requestedRootPath, paths)),
            catchError(() => {
                this.router.navigate(['/pages/not-authorized']);
                return of(false);
            })
        );
    }

    private handleAuthorization(requestedRootPath: string, allowedRootPaths: string[]): boolean {
        const isAllowed = (allowedRootPaths || []).includes(requestedRootPath);
        if (!isAllowed) {
            this.router.navigate(['/pages/not-authorized']);
        }

        return isAllowed;
    }

    private extractAllowedRootPaths(nodes: Objeto[], perfis: string[]): string[] {
        const allowed: string[] = [];
        const visit = (items: Objeto[]) => {
            (items || [])
                // .filter(item => this.hasProfileAccess(item, perfis))
                .forEach(item => {
                    const rootPath = this.getRootPath(item.endeUrl);
                    if (rootPath && allowed.indexOf(rootPath) === -1) {
                        allowed.push(rootPath);
                    }

                    if (item.children && item.children.length > 0) {
                        visit(item.children);
                    }
                });
        };

        visit(nodes);
        return allowed;
    }

    private hasProfileAccess(node: Objeto, perfis: string[]): boolean {
        const otherParents = node && node.otherParents ? node.otherParents : {};
        const objetos = Object.keys(otherParents).map(obj => (obj || '').toLowerCase());

        for (const perfil of (perfis || [])) {
            if (objetos.indexOf((perfil || '').toLowerCase()) !== -1) {
                return true;
            }
        }

        return false;
    }

    private getRootPath(url: string): string | null {
        if (!url || url === '#') {
            return null;
        }

        const cleanUrl = url.split('?')[0].split('#')[0];
        if (!cleanUrl || cleanUrl === '/') {
            return '/';
        }

        const segments = cleanUrl.split('/').filter(Boolean);
        if (segments.length === 0) {
            return '/';
        }

        return `/${segments[0]}`;
    }
}
